(ns portal.delivery-table.db
  (:require [clojure.string :as str]
            [common.db.table.backend :refer [map->InMemoryBackend]]
            [common.db.table.core :refer [register-table]]
            [mate.re-frame :as mr]
            [portal.messages :refer [ui-messages]]
            [portal.resource.delivery :as resource.delivery]
            [re-frame.core :as rf]))

(def entity-name "Delivery")

(defn update-state-to [effects {:keys [state entity]}]
  (-> effects
      (mr/update-db assoc-in [:resource.delivery/all :state] state)
      (mr/update-db assoc-in [:resource.delivery/all :entity] entity)))

(rf/reg-event-fx :table.delivery/get-all
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db resource.user/token url-context]} [_ _page]]
    (-> {:db db}
        (update-state-to {:state :pending :entity :list})
        (resource.delivery/get-all token
                                   url-context
                                   {:on-success [:table.delivery/get-all-success]
                                    :on-failure [:table.delivery/get-all-failure]}))))

(rf/reg-event-fx :table.delivery/get-all-success
  (fn [{:keys [db]} [_ response]]
    (-> {:db db}
        (mr/update-db assoc-in [:resource.delivery/all :value] response)
        (update-state-to {:state :success :entity :list}))))

(rf/reg-event-fx :table.delivery/get-all-failure
  (fn [{:keys [db]} [event response]]
    (-> {:db db}
        (update-state-to {:state :failure :entity :list})
        (mr/conj-fx [:dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :error
                                 :message (get-in ui-messages [:delivery :list :failure])
                                 :event event
                                 :response response}]]))))

(rf/reg-event-fx :table.delivery/get-details
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db resource.user/token url-context]} [_ selection]]
    (letfn [(str->map [str]
              (->> (str/split str "/")
                   (map js/parseInt)
                   (zipmap [:month :year])))]
      (-> {:db db}
          (update-state-to {:state :pending :entity :details})
          (resource.delivery/get-details token
                                         url-context
                                         {:params {:months (map str->map selection)
                                                   :file-format "xlsx"}
                                          :on-success [:table.delivery/get-details-success]
                                          :on-failure [:table.delivery/get-details-failure]})))))

(rf/reg-event-fx :table.delivery/get-details-success
  (fn [{:keys [db]} [_ response]]
    (-> {:db db}
        (update-state-to {:state :success :entity :details})
        (mr/conj-fx [:binary/download response])
        (mr/conj-fx [:dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :success
                                 :message (get-in ui-messages [:delivery :details :success])}]]))))

(rf/reg-event-fx :table.delivery/get-details-failure
  (fn [{:keys [db]} [event response]]
    (-> {:db db}
        (update-state-to {:state :failure :entity :details})
        (mr/conj-fx [:dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :error
                                 :message (get-in ui-messages [:delivery :details :failure])
                                 :event event
                                 :response response}]]))))

(def backend
  (map->InMemoryBackend
   {:on-init [:table.delivery/get-all]}))

(register-table
 {:namespace :table.delivery
  :value-sub [:resource.delivery/all]
  :initial-search {}
  :initial-sort {:column (juxt :year :month) :direction :desc}
  :initial-page {:size 10 :cursor 0}
  :backend backend})
